
import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const Swiper2 = ({ type }) => {
    const workshopImages = [
        "WS1.jpg", "WS2.jpg", "WS3.jpg", "WS4.jpg", "WS5.jpg", "WS6.jpg", "WS7.jpg", "WS8.JPG", "WS9.jpg",
        "WS10.jpg", "WS11.jpg", "WS12.jpg", "WS13.jpg", "WS14.jpg", "WS15.jpg", "WS16.JPG", "WS17.jpg", "WS18.jpg",
        "WS19.jpg", "WS20.jpg", "WS21.jpg", "WS22.jpg", "WS23.jpg", "WS24.jpg", "WS25.jpg", "WS26.jpg", "WS27.jpg", "WS28.jpg",
    ];

    const exhibitionImages = [
        "EX1.jpg", "EX3.jpg", "EX4.jpg", "EX5.jpg",
    ];

    const selectedImages = type === "exhibition" ? exhibitionImages : workshopImages;
    const folder = type === "exhibition" ? "exhibition" : "workshop";
    // const doubledImages = [...selectedImages, ...selectedImages];

    // const [isOpen, setIsOpen] = useState(false);
    // const [photoIndex, setPhotoIndex] = useState(0);


    // const duration = selectedImages.length * 4;
    let baseImages = [...selectedImages];
    if (type === "exhibition") {
        while (baseImages.length < 28) {
            baseImages = [...baseImages, ...selectedImages];
        }
    }


    const doubledImages = [...baseImages, ...baseImages];

    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);


    const duration = baseImages.length * 4;

    return (
        <div className="slidsmooth-container">
            <div className="slidsmooth-wrapper">
                <div
                    className="slidsmooth-slider"
                    style={{ animationDuration: `${duration}s` }}
                >
                    {doubledImages.map((img, index) => {
                        const isVideo = img.toLowerCase().endsWith(".mp4");
                        return (
                            <div
                                className="slidsmooth-slide"
                                key={index}
                                onClick={() => {
                                    setPhotoIndex(index);
                                    setIsOpen(true);
                                }}
                            >
                                {isVideo ? (
                                    <video
                                        src={`/assets/img/${folder}/${img}`}
                                        muted loop autoPlay playsInline
                                    />
                                ) : (
                                    <img src={`/assets/img/${folder}/${img}`} alt={`slide-${index}`}
                                        loading="eager"
                                        decoding="async"
                                        fetchPriority="high" />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>

            {isOpen && (
                <Lightbox
                    mainSrc={`/assets/img/${folder}/${doubledImages[photoIndex]}`}
                    nextSrc={`/assets/img/${folder}/${doubledImages[(photoIndex + 1) % doubledImages.length]}`}
                    prevSrc={`/assets/img/${folder}/${doubledImages[(photoIndex + doubledImages.length - 1) % doubledImages.length]}`}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() => setPhotoIndex((photoIndex + doubledImages.length - 1) % doubledImages.length)}
                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % doubledImages.length)}
                />
            )}
        </div>
    );
};

export default Swiper2;